import { createSelector } from 'reselect';

import { Selectors as QuestionsGetAllWorkersSelectors } from 'app/redux/questions/get-all/workers';
import { Selectors as QuestionsCategoryOptionsWorkersSelectors } from 'app/redux/questions/category-options/workers';

const notice = {
  title: 'Notice:',
  text: 'For best results, ignore how charming he was when you first met.',
  highlight: 'Focus on how he is treating you right now.',
};

const isWorking = createSelector(
  QuestionsGetAllWorkersSelectors.isWorking,
  QuestionsCategoryOptionsWorkersSelectors.isWorking,
  (isGetAllQuestionsWorking, isGetCategoryOptionsWorking) =>
    isGetAllQuestionsWorking || isGetCategoryOptionsWorking
);

export const getSelectedAnswers = state => state.uiQuestions.selectedAnswers;

const Selectors = createSelector(
  QuestionsGetAllWorkersSelectors.result,
  QuestionsCategoryOptionsWorkersSelectors.result,
  getSelectedAnswers,
  isWorking,
  (questionResults, categoryOptions, selectedAnswers, isWorking) => {
    const questionIdsArray = questionResults && Object.keys(questionResults);
    const questionCount = questionIdsArray && questionIdsArray.length;

    return {
      notice,
      questionCount,
      questionResults,
      questionIdsArray,
      categoryOptions,
      selectedAnswers,
      isWorking,
    };
  }
);

export default Selectors;



// WEBPACK FOOTER //
// ./src/redux/ui/questions/selectors.js